import validate from "/codebuild/output/src1852518591/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/codebuild/output/src1852518591/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/codebuild/output/src1852518591/src/middleware/admin.js"),
  authenticated: () => import("/codebuild/output/src1852518591/src/middleware/authenticated.js"),
  home: () => import("/codebuild/output/src1852518591/src/middleware/home.js"),
  yarn: () => import("/codebuild/output/src1852518591/src/middleware/yarn.js")
}